import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledBox = styled(Box)(({ theme }) => ({
  '& .CSTableContainer': {
    margin: theme.spacing(3, 0),
    boxShadow: 'none',
    '.MuiTableRow-root:last-child .MuiTableCell-root': {
      border: 0,
    },
    '& table thead [class*="MuiTableCell-root"]': {
      fontWeight: 500,
    },
    '& table [class*="MuiTableCell-root"]': {
      paddingLeft: '0 !important',
      paddingRight: '0 !important',
    },
    '& table tbody [class*="MuiTableRow-root"]:nth-of-type(odd):not(.tfoot)': {
      backgroundColor: 'transparent',
    },
    '& .MuiTableCell-alignCenter': {
      textAlign: 'center',
    },
    '& .CSCheckIcon': {
      color: theme.palette.success.main,
    },
    '& .CSdiabledCheck': {
      color: theme.palette.grey[100],
    },
    '& .CSBookPrice': {
      margin: theme.spacing(1, 0),
    },
  },
  '& .CStitle': {
    [theme.breakpoints.up('lg')]: {
      marginTop: theme.spacing(5.25),
    },
    [theme.breakpoints.down('lg')]: {
      marginBottom: theme.spacing(4.5),
    },
  },
  '& .CSimg': {
    position: 'absolute',
    left: '0',
    height: '100%',
    width: '25.7%',
  },
  '& .CSoverlayColor': {
    position: 'absolute',
    top: '0',
    width: '100%',
    height: '100%',
    color: theme.palette.common.fogWhite,
    background: `linear-gradient(180deg, ${theme.palette.secondary.main}80 0%, rgba(242, 107, 0, 0) 100%)`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    '& svg': {
      width: theme.typography.pxToRem(50),
      height: theme.typography.pxToRem(50),
    },
  },
  '& .CSHiddencell': {
    [theme.breakpoints.down('lg')]: {
      display: 'none',
    },
  },
  '& .CMSStarting': {
    color: theme.palette.grey[300],
  },
  '& .CMStopSection': {
    border: `1px solid ${theme.palette.grey[100]}`,
    borderRadius: theme.typography.pxToRem(12),
    padding: theme.typography.pxToRem(16),
  },
  '& .IBimg': {
    objectPosition: '78%',
  },
  '& .CSStartingAtText': {
    color: theme.palette.grey[300],
  },
}));

export default StyledBox;
